module.exports = __webpack_public_path__ + "img/socio2.2d73d421.png";